import {Open} from './Open';
import {Radio} from './Radio';
import {Checkbox} from './Checkbox';
import {Props} from './Props';
import {Header} from 'app/models/questions/Header'
import {Phone} from 'app/models/questions/Phone'
import {Image} from 'app/models/questions/Image'
import {CheckboxMatrix} from 'app/models/questions/CheckboxMatrix'
import {Name} from 'app/models/questions/Name'
import {RadioMatrix} from 'app/models/questions/RadioMatrix'
import {Kano} from 'app/models/questions/Kano'
import {Email} from 'app/models/questions/Email'
import {Address} from 'app/models/questions/Address'
import {ViewerTypeEnum} from 'app/enums/ViewerTypeEnum'
import {HoneyPot} from "./HoneyPot";
import {PriceRange} from "./PriceRange";
import {ImageUpload} from "./ImageUpload";
import {AudioRecorder} from "./AudioRecorder";

export const QuestionTypeToClassMap = {
  [ViewerTypeEnum.OPEN]: Open,
  [ViewerTypeEnum.RADIO]: Radio,
  [ViewerTypeEnum.CHECKBOX]: Checkbox,
  [ViewerTypeEnum.PROPS]: Props,
  [ViewerTypeEnum.HEADER]: Header,
  [ViewerTypeEnum.IMAGE]: Image,
  [ViewerTypeEnum.CHECKBOX_MATRIX]: CheckboxMatrix,
  [ViewerTypeEnum.RADIO_MATRIX]: RadioMatrix,
  [ViewerTypeEnum.NAME]: Name,
  [ViewerTypeEnum.EMAIL]: Email,
  [ViewerTypeEnum.ADDRESS]: Address,
  [ViewerTypeEnum.PHONE]: Phone,
  [ViewerTypeEnum.KANO]: Kano,
  [ViewerTypeEnum.HONEYPOT]: HoneyPot,
  [ViewerTypeEnum.PRICERANGE]: PriceRange,
  [ViewerTypeEnum.IMAGEUPLOAD]: ImageUpload,
  [ViewerTypeEnum.AUDIORECORDER]: AudioRecorder,
}
